import Api from '../api';

class SensorboxGroupService {
  createSensorboxGroup = async (payload: any, orgid?: string) => {
    let url = '/sensorbox-group';
    if (orgid) {
      url += `?orgid=${orgid}`;
    }
    return Api.post(url, payload);
  }

  getSensorboxGroups = async (params: any) => {
    const query = new URLSearchParams(params).toString();
    let url = query ? `/sensorbox-group?${query}` : '/sensorbox-group';
    return Api.get(url);
  }

  getSensorboxGroupById = async (id: string, orgid?: string) => {
    let url = `/sensorbox-group/${id}`;
    if (orgid) {
      url += `?orgid=${orgid}`;
    }
    return Api.get(url);
  }

  updateSensorboxGroup = async (id: string, payload: any, orgid?: string) => {
    let url = `/sensorbox-group/${id}`;
    if (orgid) {
      url += `?orgid=${orgid}`;
    }
    return Api.put(url, payload);
  }

  deleteSensorboxGroup = async (id: string, orgid?: string) => {
    let url = `/sensorbox-group/${id}`;
    if (orgid) {
      url += `?orgid=${orgid}`;
    }
    return Api.delete(url);
  }

  getSensorboxesForGroup = async (orgid?: string) => {
    let url = '/sensorboxes-for-group';
    if (orgid) {
      url += `?orgid=${orgid}`;
    }
    return Api.get(url);
  }

  isGroupNameExist = async (name: string, groupId?: string, orgid?: string) => {
    let url = `/sensorbox-group_exist/${name}`;
    const params = new URLSearchParams();
    if (groupId) {
      params.append('gid', groupId);
    }
    if (orgid) {
      params.append('orgid', orgid);
    }
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    return Api.get(url);
  }

  // Attachment methods
  addSensorboxGroupAttachment = async (id: string, formData: FormData, orgid?: string) => {
    let url = `/sensorbox-group/${id}/attachment`;
    if (orgid) {
      url += `?orgid=${orgid}`;
    }
    return Api.post(url, formData);
  }

  getSensorboxGroupAttachment = async (attachmentName: string) => {
    return Api.get(`/sensorbox-group/attachment/${attachmentName}`, {
      responseType: 'blob',
    });
  }

  deleteSensorboxGroupAttachment = async (id: string, attachmentId: string, fileId: string, orgid?: string) => {
    let url = `/sensorbox-group/${id}/attachment/${attachmentId}/file/${fileId}`;
    if (orgid) {
      url += `?orgid=${orgid}`;
    }
    return Api.delete(url);
  }

}

export default new SensorboxGroupService();